var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.4 6.4C6.465 6.4 5.7 7.165 5.7 8.1H4V11.5H5.7C5.7 11.9509 5.87911 12.3833 6.19792 12.7021C6.51673 13.0209 6.94913 13.2 7.4 13.2H14.2L17.6 16.6H19.3V3H17.6L14.2 6.4H7.4Z",
    fill: "#464E5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.75V20H9.95L8.5305 15.75H7.4V14.05H14.2V15.75H12.5Z",
    fill: "#C9C9D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementIcon);
export default __webpack_public_path__ + "static/media/announcement-icon.232b8948353059027eff1bdb2c0c4330.svg";
export { ForwardRef as ReactComponent };